<script>
import EventBus from "@/helpers/eventBus";

export default {
  data() {
    return {
      props_before: "",
      pvroute: sessionStorage.getItem("prevRoute"),
    };
  },
  components: {},
  props: {
    prevRoutePath: {
      type: String,
      default: sessionStorage.getItem("prevRoute"),
    },
    backButton: {
      type: Boolean,
      default: false,
    },
    backWithData: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    items: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    prevRoutePath: {
      immediate: true,
      handler(n, o) {
        if (n != "") {
          sessionStorage.setItem("prevRoute", n);
          this.pvroute = n;
        }
      },
    },
  },
  methods: {
    onBack() {
      if (!this.backWithData) return;
      EventBus.$emit("sendBackProps", this.props_before);
    },
    // recieveProps(){
    //   let data = []
    //   EventBus.$once("sendProps", (val) => {
    //     this.props_before = val
    //     console.log('ev => ', val);
    //   });
    // },
    logdata(msg) {
      console.log(msg, this.props_before);
    },
    handler1(val) {
      this.props_before = val;
      this.logdata("hmm=>> ");
    },
  },
  // created() {
  //   this.recieveProps();
  //   setTimeout(() => {
  //     this.logdata('lala => ');
  //   }, 2000);
  // },
};
</script>

<template>
  <!-- start page title -->
  <div class="row mb-3">
    <div class="col-12">
      <div
        class="
          page-title-box
          d-flex
          align-items-center
          justify-content-between
          pb-0
        "
      >
        <div class="d-flex align-items-center">
          <div v-if="backButton">
            <router-link :to="pvroute">
              <b-button pill variant="light" @click="onBack">
                <i class="mdi mdi-18px mdi-arrow-left"></i>
              </b-button>
            </router-link>
          </div>
          <h4 class="ml-2 mb-0 font-size-18">{{ title }}</h4>
        </div>

        <div class="page-title-right">
          <b-breadcrumb :items="items" class="m-0"></b-breadcrumb>
        </div>
      </div>
      <!-- <hr> -->
    </div>
  </div>
  <!-- end page title -->
</template>
